import { UPDATEVISIBILITY_SUCCESS, UPDATEVISIBILITY_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const updateVisibilityReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATEVISIBILITY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATEVISIBILITY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default updateVisibilityReducer;
